<h2 mat-dialog-title>
  {{ 'APP.DIALOGS.UNASSIGNABLE_DOCUMENT.TITLE' | translate }}
</h2>
<button
  matDialogClose
  type="button"
  class="wk-button wk-button-icon wk-button-close close-icon"
>
  <span class="wk-icon-filled-close" aria-hidden="true"></span>
</button>

<mat-dialog-content>
  <p>
    {{
      (!canReassign
        ? 'APP.DIALOGS.UNASSIGNABLE_DOCUMENT.LOCKED_DOCUMENT'
        : 'APP.DIALOGS.UNASSIGNABLE_DOCUMENT.LOCKED_DOCUMENT_GENERIC_MSG'
      ) | translate
    }}
  </p>
</mat-dialog-content>

<div class="dialog-actions">
  <button matDialogClose class="wk-button" type="button">
    {{ 'APP.ACTIONS.CLOSE' | translate }}
  </button>
</div>
